import { render, staticRenderFns } from "./basicTab.vue?vue&type=template&id=270d9fbe&scoped=true&"
import script from "./basicTab.vue?vue&type=script&lang=js&"
export * from "./basicTab.vue?vue&type=script&lang=js&"
import style0 from "./basicTab.vue?vue&type=style&index=0&id=270d9fbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270d9fbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('270d9fbe')) {
      api.createRecord('270d9fbe', component.options)
    } else {
      api.reload('270d9fbe', component.options)
    }
    module.hot.accept("./basicTab.vue?vue&type=template&id=270d9fbe&scoped=true&", function () {
      api.rerender('270d9fbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaImport/components/Prediction/basicTab.vue"
export default component.exports